import {ExamResultStatus} from './get-exam-results';

enum ExamRequestResultTypeEnum {
	LABORATORY = 'LABORATORIAL',
	VARIED = 'LABORATORIAL E IMAGEM',
	IMAGE = 'IMAGEM',
	ALL = 'ALL',
}

type ExamRequestResultsType = Exclude<ExamRequestResultTypeEnum, ExamRequestResultTypeEnum.ALL>;

type GetExamRequestsParams = {
	entryPoint?: string;
	requestNumber?: string;
	referenceDate?: string | Date;
	startDate?: string;
	endDate?: string;
	statusType?: string;
	examType?: string;
	page?: number;
	limit?: number;
	signal?: AbortSignal;
};

interface ExamRequest {
	nuPedido: number;
	dtPedido: string;
	cdPrestadorJuridico: number;
	dsPrestadorJuridico: string;
	dsStatus: ExamResultStatus;
	dsTipoExame: ExamRequestResultsType;
	nmSolicitante: string;
}

type GetExamRequestsModel = {
	total: number;
	totalPerPage: number;
	result: ExamRequest[];
};

interface GetExamRequests {
	get: (params: GetExamRequestsParams) => Promise<GetExamRequestsModel>;
}

export type {
	GetExamRequests,
	GetExamRequestsParams,
	GetExamRequestsModel,
	ExamRequest,
	ExamRequestResultsType,
};

export {ExamRequestResultTypeEnum};
